export default __webpack_public_path__ + "static/media/openlock_icon.392f4a2e.svg";